import gql from 'graphql-tag'

export default gql`
query getregistrationCount($slug: String){
  registrationCount(filter:{
    slug: $slug
  })
}
`